import approvedIcon from "../../../assets/icons/approved.png";
import reprovedIcon from "../../../assets/icons/reproved.png";

import styles from "./GradeCard.module.css";

function GradeCard({
	title,
	subtitle,
	finalGrade,
	maxGrade,
	approved = "default",
	approvedText = "Concluído",
	reprovedText = "Reprovado",
	customColorFunction = false,
	showIcon = true,
}) {
	function defaultColorStyle(approved) {
		if (approved === "default") {
			return null;
		} else if (approved) {
			return styles.approved;
		} else {
			return styles.reproved;
		}
	}

	const colorStyle = customColorFunction
		? customColorFunction(approved)
		: defaultColorStyle(approved);
	const mainCardStyles = [styles.mainCard, colorStyle].join(" ");
	const finalGradeStyles = [styles.finalValue, colorStyle].join(" ");
	const badgeStyles = [styles.badge, colorStyle].join(" ");
	return (
		<div className={styles.container}>
			<div className={mainCardStyles}>
				<div className={styles.title}>{title}</div>
				<div className={styles.subtitle}>{subtitle}</div>
				<div className={finalGradeStyles}>
					{typeof finalGrade === "number" && finalGrade.toFixed(2)}{" "}
					{typeof finalGrade === "number" ? "/" : "-"}{" "}
					{typeof finalGrade === "number" && maxGrade.toFixed(2)}
				</div>
				<div className={badgeStyles}>
					{approved !== "default" && showIcon && (
						<img
							src={approved ? approvedIcon : reprovedIcon}
							alt={approved ? approvedText : reprovedText}
						/>
					)}
					{approved ? approvedText : reprovedText}
				</div>
			</div>
		</div>
	);
}

export default GradeCard;
